<template>
  <div id="rightMainContainer" style="width:100%">
    <navAndSearch @pf5="parent5"></navAndSearch>
    <fileTable ref="goodslist"></fileTable>
  </div>
</template>

<script>
import navAndSearch from "./nav/nav";
import fileTable from "./fileTable/fileTable";
import { mapState } from "vuex";
export default {
  name: "Myshare",
  components: {
    navAndSearch,
    fileTable
  },
  computed: {
    ...mapState({
      rightW: state => state.perFile.rightW,
      currentNode: state => state.perFile.currentTreeNodeDan
    })
  },
  methods: {
    parent5() {
      this.$refs.goodslist.querlist2();
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#rightMainContainer {
  height: 100%;
  background-color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
}
::v-deep span{
  font-size: 14px !important;
}
::v-deep .cell{
  font-size: 14px !important;
}
</style>
